module.exports = __webpack_public_path__ + "media/leadPages/transition-photo-d8f9a650.png";